import { render, staticRenderFns } from "./ConpackGift.vue?vue&type=template&id=6176cee6&scoped=true&"
import script from "./ConpackGift.vue?vue&type=script&lang=js&"
export * from "./ConpackGift.vue?vue&type=script&lang=js&"
import style0 from "./ConpackGift.vue?vue&type=style&index=0&id=6176cee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176cee6",
  null
  
)

export default component.exports